var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0833 33.2502C11.0833 31.5013 12.501 30.0835 14.2499 30.0835C15.9988 30.0835 17.4166 31.5013 17.4166 33.2502C17.4166 34.9991 15.9988 36.4168 14.2499 36.4168C12.501 36.4168 11.0833 34.9991 11.0833 33.2502Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 33.2502C28.5 31.5013 29.9178 30.0835 31.6667 30.0835C33.4156 30.0835 34.8333 31.5013 34.8333 33.2502C34.8333 34.9991 33.4156 36.4168 31.6667 36.4168C29.9178 36.4168 28.5 34.9991 28.5 33.2502Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.58333C0 0.708882 0.708883 0 1.58333 0H7.91667C8.67133 0 9.3211 0.53261 9.46921 1.27259L10.799 7.91667H36.4167C36.8885 7.91667 37.3358 8.12714 37.6366 8.49071C37.9374 8.85429 38.0604 9.33308 37.972 9.7966L35.4364 23.0926C35.2192 24.1861 34.6243 25.1683 33.7559 25.8673C32.8918 26.5629 31.8117 26.934 30.703 26.9167H15.3404C14.2316 26.934 13.1515 26.5629 12.2874 25.8673C11.4194 25.1686 10.8247 24.1869 10.6073 23.094C10.6072 23.0935 10.6074 23.0944 10.6073 23.094L7.96225 9.87874C7.95152 9.83502 7.94261 9.7906 7.93559 9.74554L6.61883 3.16667H1.58333C0.708883 3.16667 0 2.45778 0 1.58333ZM11.4328 11.0833L13.713 22.4757C13.7854 22.8402 13.9837 23.1676 14.2731 23.4006C14.5626 23.6336 14.9248 23.7574 15.2963 23.7503L15.3267 23.75H30.7167L30.747 23.7503C31.1185 23.7574 31.4807 23.6336 31.7702 23.4006C32.0583 23.1687 32.2561 22.8432 32.3293 22.4808L34.5029 11.0833H11.4328Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.263dca6b6efef10f7f6a3aa195553b83.svg";
export { ForwardRef as ReactComponent };